import { useMemo, useEffect } from 'react';

import {
  ChecklistItemDtoStatus,
  useListMeetingsInfo,
  useListSharedMeetingsInfo
} from '@/api/generated';
import { useCheckList } from '@/hooks/useCheckList';
import { CheckListEnumTitles } from '@/pages/HomePage/components/checklist/CheckListConfig';
import { defaultDateRange } from '@/pages/meetingsHub/util';

const useMeetingsViewLogic = () => {
  const { isItemCompleted, updateCheckList } = useCheckList();
  const isApproveBotToAMeetingCompleted = isItemCompleted(CheckListEnumTitles.ApproveBotToAMeeting);

  const { data: meetingResponse, isLoading: meetingLoading } = useListMeetingsInfo(
    {
      from: defaultDateRange.startDate,
      to: defaultDateRange.endDate
    },
    {
      query: {
        refetchOnWindowFocus: false
      }
    }
  );

  const { data: sharedMeetingResponse, isLoading: sharedMeetingLoading } =
    useListSharedMeetingsInfo(
      {
        from: defaultDateRange.startDate,
        to: defaultDateRange.endDate
      },
      {
        query: {
          refetchOnWindowFocus: false
        }
      }
    );

  const meetings = useMemo(
    () =>
      [...(meetingResponse?.items ?? []), ...(sharedMeetingResponse?.items ?? [])].sort((a, b) => {
        const aTime = a.startTime ? new Date(a.startTime).getTime() : 0;
        const bTime = b.startTime ? new Date(b.startTime).getTime() : 0;
        return bTime - aTime;
      }),
    [meetingResponse, sharedMeetingResponse]
  );

  useEffect(() => {
    if (isApproveBotToAMeetingCompleted || meetings.length < 1) return;
    updateCheckList({
      title: CheckListEnumTitles.ApproveBotToAMeeting,
      status: ChecklistItemDtoStatus.completed
    });
  }, [meetings, updateCheckList, isApproveBotToAMeetingCompleted]);

  const loading = useMemo(
    () => meetingLoading || sharedMeetingLoading,
    [meetingLoading, sharedMeetingLoading]
  );

  return {
    meetings,
    loading
  };
};

export default useMeetingsViewLogic;
